import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function Container({ className = "", children }) {
  return <div className={`mx-auto w-full max-w-6xl px-6 lg:px-8 ${className}`}>{children}</div>;
}

export function SectionLabel({ children, className = "" }) {
  return <p className={`text-xs font-bold uppercase tracking-[0.22em] text-neutral-400 ${className}`}>{children}</p>;
}

const primaryCls =
  "inline-flex items-center justify-center gap-2 rounded-full bg-neutral-900 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-neutral-700";
const outlineCls =
  "inline-flex items-center justify-center gap-2 rounded-full border border-neutral-300 bg-white px-6 py-3 text-sm font-semibold text-neutral-900 transition-colors hover:border-neutral-900";

export function PrimaryLink({ to, href, children, testid, className = "" }) {
  if (href) return <a href={href} className={`${primaryCls} ${className}`} data-testid={testid}>{children}</a>;
  return <Link to={to} className={`${primaryCls} ${className}`} data-testid={testid}>{children}</Link>;
}

export function OutlineLink({ to, href, children, testid, className = "" }) {
  if (href) return <a href={href} className={`${outlineCls} ${className}`} data-testid={testid}>{children}</a>;
  return <Link to={to} className={`${outlineCls} ${className}`} data-testid={testid}>{children}</Link>;
}

export function CtaBand({ title = "Klar for å ta kontroll over styrearbeidet?" }) {
  return (
    <Container className="py-16 sm:py-24">
      <div className="rounded-[2rem] bg-[#CDF546] px-8 py-14 sm:px-14 sm:py-20">
        <h2 className="max-w-2xl font-headings text-3xl font-extrabold leading-[1.05] tracking-tight text-neutral-900 sm:text-5xl">{title}</h2>
        <p className="mt-5 max-w-xl text-base text-neutral-800">
          199 kr i måneden per selskap — alt inkludert. Vi viser deg styrerommet med dine egne selskaper på 20 minutter.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <PrimaryLink to="/priser" testid="cta-band-priser">Se priser <ArrowRight className="h-4 w-4" /></PrimaryLink>
          <OutlineLink to="/kontakt" testid="cta-band-demo">Book demo</OutlineLink>
        </div>
      </div>
    </Container>
  );
}

export function PageHero({ label, title, children }) {
  return (
    <Container className="pb-8 pt-16 sm:pt-24">
      <SectionLabel>{label}</SectionLabel>
      <h1 className="mt-4 max-w-4xl font-headings text-4xl font-extrabold leading-[1.02] tracking-tight text-neutral-900 sm:text-6xl">{title}</h1>
      {children ? <p className="mt-6 max-w-2xl text-lg leading-relaxed text-neutral-600">{children}</p> : null}
    </Container>
  );
}
